import React from 'react';

import { Circle, ReportToolTip } from 'pages/reports/components/StudentMetricsDisplay/StudentMetricsDisplay';
import { FormattedMessage, useIntl } from 'react-intl';
import { Card, Col, Row } from 'react-bootstrap';

import 'pages/reports/components/Report68/CourseSummaryCard.scss';

interface CourseSummaryCardProps {
    completedDate: string | null;
    lastAccess: string;
    progress: number;
    startedDate: string;
    timeSpent: string;
}

export const CourseSummaryCard: React.FC<CourseSummaryCardProps> = ({
    completedDate,
    lastAccess,
    progress,
    startedDate,
    timeSpent
}) => {

    const { formatMessage } = useIntl();

    return (
        <Card className="course-summary-card">
            <Card.Body className="p-4">
                <Row className="align-items-center justify-content-around text-center">
                    <Col className="summary-item" md={2} xs={12}>
                        <ReportToolTip
                            tooltip={formatMessage({ id: 'date_the_student_first_launched_any_reso.78e89041', defaultMessage: 'Date the student first launched any resource in this course in this classroom.' })}
                            trigger="hover"
                        >
                            <div>
                                <div className="fw-semibold text-secondary mb-2">
                                    <FormattedMessage defaultMessage="Started" id="started.d612a775" />
                                </div>
                                <div className="fw-bold fs-4">
                                    {startedDate}
                                </div>
                            </div>
                        </ReportToolTip>
                    </Col>

                    <Col className="summary-item" md={2} xs={12}>
                        <ReportToolTip
                            tooltip={formatMessage({ id: 'percent_of_resources_in_this_course_the.5f807e7e', defaultMessage: 'Percent of resources in this course the student has completed.' })}
                            trigger="hover"
                        >
                            <div className="progress-circle-wrapper">
                                {/* Progress circle */}
                                <Circle label={formatMessage({ id: 'progress.2797cee5', defaultMessage: 'Progress' })} value={progress} />
                            </div>
                        </ReportToolTip>
                    </Col>

                    <Col className="summary-item" md={2} xs={12}>
                        <ReportToolTip
                            tooltip={formatMessage({ id: 'date_the_course_was_marked_complete_for.38199c9c', defaultMessage: 'Date the course was marked complete for this student in this classroom.' })}
                            trigger="hover"
                        >
                            <div>
                                <div className="fw-semibold text-secondary mb-2">
                                    <FormattedMessage defaultMessage="Completed" id="completed.cd3d7862" />
                                </div>
                                <div className="fw-bold fs-4">
                                    {completedDate || formatMessage({ id: 'not_completed.2438f3af', defaultMessage: 'Not Completed' })}
                                </div>
                            </div>
                        </ReportToolTip>
                    </Col>

                    <Col className="summary-item" md={2} xs={12}>
                        <ReportToolTip
                            tooltip={formatMessage({ id: 'total_time_this_student_has_spent_on_all.16c6056a', defaultMessage: 'Total time this student has spent on all course resources, including time on all assessment attempts and non-assessment resources.' })}
                            trigger="hover"
                        >
                            <div>
                                <div className="fw-semibold text-secondary mb-2">
                                    <FormattedMessage defaultMessage="Time Spent" id="time_spent.da775c0c" />
                                </div>
                                <div className="fw-bold fs-4">
                                    {timeSpent}
                                </div>
                            </div>
                        </ReportToolTip>
                    </Col>

                    <Col className="summary-item" md={2} xs={12}>
                        <ReportToolTip
                            tooltip={formatMessage({ id: 'most_recent_date_this_student_interacted.657b3446', defaultMessage: 'Most recent date this student interacted with any resource in this course.' })}
                            trigger="hover"
                        >
                            <div>
                                <div className="fw-semibold text-secondary mb-2">
                                    <FormattedMessage defaultMessage="Last Access" id="last_access.6fd7ff0b" />
                                </div>
                                <div className="fw-bold fs-4">
                                    {lastAccess}
                                </div>
                            </div>
                        </ReportToolTip>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );

};
